import type { QuoteForConsumer } from "@/services/quoteRequestsService";

/** The two identity fields a bid carries, in the order they are preferred. */
export type QuoteProfessionalIdentity = Pick<
  QuoteForConsumer,
  "professionalDisplayName" | "professionalOrdinal"
>;

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * How a bidding professional is named to the consumer.
 *
 * Three levels, in order: the real name (revealed only once the quote is
 * awarded), the anonymous ordinal shared with the clarification threads and
 * the timeline, and only then the generic fallback.
 *
 * This lives here rather than inline at each surface because it was inline at
 * two of them and they disagreed: the bid row resolved the ordinal and showed
 * "Profesional 1", while the award confirmation skipped that level and showed
 * "Un profesional" for the same bid. The consumer read both within one click.
 */
export function resolveQuoteProfessionalName(
  quote: QuoteProfessionalIdentity,
  t: Translate,
): string {
  if (quote.professionalDisplayName != null) return quote.professionalDisplayName;
  if (quote.professionalOrdinal != null) {
    return t("requests.clarifications.askerAnonymous", { count: quote.professionalOrdinal });
  }
  return t("requests.user.quoteReviewUnknownProfessional");
}
